module.exports = __webpack_public_path__ + "img/newsletter-1.543c1c48.svg";